import { Circle, Archive, EyeOff } from "lucide-react";

const STATUS = {
  active: { txt: "Aktívny", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "text-emerald-500" },
  contacted: { txt: "Kontaktovaný", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "text-blue-500" },
  inactive: { txt: "Neaktívny", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "text-amber-500" },
  rejected: { txt: "Zamietnutý / archivovaný", cls: "bg-red-50 text-red-600 border-red-200", dot: "text-red-500" },
};

export function StatusBadge({ profile, size = "sm" }) {
  const pad = size === "sm" ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm";
  if (profile?.anonymized) {
    return (
      <span data-testid="status-badge" className={`inline-flex items-center gap-1.5 rounded-full border bg-slate-100 text-slate-600 border-slate-300 font-semibold ${pad}`}>
        <EyeOff size={13} /> Anonymizovaný
      </span>
    );
  }
  if (profile?.archived) {
    return (
      <span data-testid="status-badge" className={`inline-flex items-center gap-1.5 rounded-full border bg-red-50 text-red-600 border-red-200 font-semibold ${pad}`}>
        <Archive size={13} /> Archivovaný
      </span>
    );
  }
  const s = STATUS[profile?.candidate_status] || STATUS.active;
  return (
    <span data-testid="status-badge" className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${s.cls} ${pad}`}>
      <Circle size={9} className={`fill-current ${s.dot}`} /> {s.txt}
    </span>
  );
}
